import type { FormField } from '../../types';
import { FormFieldWrapper } from './FormFieldWrapper';

interface Props { field: FormField; value: unknown; onChange: (v: unknown) => void; error?: string; }
export function TextareaField({ field, value, onChange, error }: Props) {
  return (
    <FormFieldWrapper field={field} error={error} labelFor={field.fieldId}>
      <textarea id={field.fieldId} rows={4} value={String(value ?? '')} onChange={e => onChange(e.target.value)}
        placeholder={field.placeholder} aria-invalid={!!error} />
    </FormFieldWrapper>
  );
}
